import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'campaign/create',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./CampaignCreate').default
      callback(null, component)
    }, 'CampaignCreate')
  }
})



// WEBPACK FOOTER //
// ./src/routes/rule-ui-routes/CampaignCreate/index.js